import React from 'react';
import { Link } from 'react-router-dom';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import Whyimg01 from '../../../assets/images/why-choose/why-choose-five-1.jpg';
import Whyimg02 from '../../../assets/images/why-choose/why-choose-five-icon-1.svg';
import Whyimg03 from '../../../assets/images/why-choose/why-choose-five-2.jpg';
import Whyimg04 from '../../../assets/images/why-choose/why-choose-five-icon-2.svg';
import Whyimg05 from '../../../assets/images/why-choose/why-choose-five-3.jpg';
import Whyimg06 from '../../../assets/images/why-choose/why-choose-five-icon-3.svg';

const Whychooseus = () => {
    return (
        <>
            <div className="why-choose-section-five">
                <div className="container why-choose-inner-five">
                    <div className="row">
                        <div className="col-xl-5 col-lg-8 m-auto">
                            <div className="heading-box text-center">
                                <span
                                    className="sub-title-two animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                >
                                    Why Choose us
                                </span>
                                <h2
                                    className="heading-title animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="200ms"
                                >
                                    Our skills are the main reasons why&nbsp;clients choose us
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row gutter-y-30">
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="why-choose-box-five animate fadeInUp wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <div className="why-choose-image-five">
                                    <img
                                        src={Whyimg01}
                                        alt="why-choose-image"
                                    />
                                </div>
                                <div className="why-choose-details-five">
                                    <img
                                        src={Whyimg02}
                                        alt="icon"
                                    />
                                    <h4>Customized Solutions</h4>
                                    <p>Provide affordable business.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="why-choose-box-five animate fadeInUp wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="400ms"
                            >
                                <div className="why-choose-image-five">
                                    <img
                                        src={Whyimg03}
                                        alt="why-choose-image"
                                    />
                                </div>
                                <div className="why-choose-details-five">
                                    <img
                                        src={Whyimg04}
                                        alt="icon"
                                    />
                                    <h4>Experience and Expertise</h4>
                                    <p>We stay with the latest technology.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="why-choose-box-five animate fadeInUp wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="600ms"
                            >
                                <div className="why-choose-image-five">
                                    <img
                                        src={Whyimg05}
                                        alt="why-choose-image"
                                    />
                                </div>
                                <div className="why-choose-details-five">
                                    <img
                                        src={Whyimg06}
                                        alt="icon"
                                    />
                                    <h4>Trust and Reliability</h4>
                                    <p>We specialize in industries, healthcare.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="why-choose-five-two">
                    <div className="container">
                        <div className="row gutter-y-40">
                            <div className="col-lg-4">
                                <div
                                    className="why-choose-left-five animate fadeInLeft wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="200ms"
                                >
                                    <div className="heading-box">
                                        <h2 className="heading-title">
                                            Customers are served behind the digital marketing
                                        </h2>
                                    </div>
                                    <p className="lead">
                                        Uniqo offers full range of consultancy &amp; training for data
                                        consultation strategic ways for business.
                                    </p>
                                    <Link to="/Aboutus" className="btn btn-light btn-theme">
                                        View More <span>+</span>
                                    </Link>
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <div className="why-choose-right-five">
                                    <div className="row gutter-y-30">
                                        <div className="col-lg-4 col-md-4">
                                            <div
                                                className="why-choose-box-five-two animate fadeInRight wow"
                                                data-wow-duration="1500ms"
                                                data-wow-delay="200ms"
                                            >
                                                <div className="why-choose-box-icon">
                                                    <div
                                                        className="circleGraphic"
                                                        data-circle-options='{
                                          "color": "#C9A885",
                                          "value": 45
                                        }'
                                                    />
                                                    <span>45%</span>
                                                    <CircularProgressbar
                                                        value={45}
                                                        styles={buildStyles({
                                                            pathColor: '#C9A885',
                                                            textColor: '#000',
                                                            trailColor: '#d6d6d6',


                                                        })}
                                                    />
                                                </div>
                                                <h4>Business Development</h4>
                                                <p>
                                                    Consistently ranked among the top consulting firms across
                                                    the nation.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4">
                                            <div
                                                className="why-choose-box-five-two animate fadeInRight wow"
                                                data-wow-duration="1500ms"
                                                data-wow-delay="400ms"
                                            >
                                                <div className="why-choose-box-icon">
                                                    <div
                                                        className="circleGraphic"
                                                        data-circle-options='{
                                          "color": "#C9A885",
                                          "value": 65
                                        }'
                                                    />
                                                    <span>65%</span>
                                                    <CircularProgressbar
                                                        value={65}
                                                        styles={buildStyles({
                                                            pathColor: '#C9A885',
                                                            textColor: '#000',
                                                            trailColor: '#d6d6d6',


                                                        })}
                                                    />
                                                </div>
                                                <h4>Financial Reporting</h4>
                                                <p>
                                                    Dedicated to providing personal attention to all our
                                                    clients.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4">
                                            <div
                                                className="why-choose-box-five-two animate fadeInRight wow"
                                                data-wow-duration="1500ms"
                                                data-wow-delay="600ms"
                                            >
                                                <div className="why-choose-box-icon">
                                                    <div
                                                        className="circleGraphic"
                                                        data-circle-options='{
                                          "color": "#C9A885",
                                          "value": 85
                                        }'
                                                    />
                                                    <span>85%</span>
                                                    <CircularProgressbar
                                                        value={85}
                                                        styles={buildStyles({
                                                            pathColor: '#C9A885',
                                                            textColor: '#000',
                                                            trailColor: '#d6d6d6',


                                                        })}
                                                    />
                                                </div>
                                                <h4>Investment Analysis</h4>
                                                <p>
                                                    We take pride fighting for individuals, not big insurance
                                                    companies.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Whychooseus
